import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { withStyles } from "@mui/styles";
import { observer } from "mobx-react";
import { styles } from "../Styles";
import { ListDistributionTypes } from "../operations/DistributionOperations";
import { Box, InputLabel, TextField } from "@mui/material";
import TaskProgressEchart from "./TaskProgressEchart";
import DistributionForm from "./DistributionForm";
import Distribution from "../model/Distribution";
import Button from "@mui/material/Button";
import DialogCustomDistribution from "../dialogs/DialogCustomDistribution";
import Task from "../model/Task";
import FormControl from "@mui/material/FormControl";
import DialogCalculatePlan from "../dialogs/DialogCalculatePlan";

const DisplayChart = ({ visibility, task }) => {
  return visibility ? <TaskProgressEchart taskObject={[task]} /> : <div></div>;
};

const TaskDistributionPicker = ({ task }) => {
  const [selectOptions, setSelectOptions] = useState([]);
  const [isChartVisible, setIsChartVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [isCalculatePlanOpen, setCalculatePlanOpen] = useState(false);

  const isTask = task instanceof Task;

  useEffect(() => {
    if (
      !task.distribution &&
      task.plannedProgress &&
      task.plannedProgress.size > 0
    ) {
      task.applyDistribution("Uniform");
    }
    ListDistributionTypes((options) => {
      const result = options.map((option) => {
        return (
          <MenuItem key={option.code} value={option.code}>
            {option.name}
          </MenuItem>
        );
      });
      setSelectOptions(result);
    });
  }, [task]);

  const handleChange = (task, event) => {
    let value = event.target.value;
    task.distribution = new Distribution(task.project, task, value, value);
    if (value === "Custom") {
      setOpen(true);
    } else {
      setCalculatePlanOpen(true);
    }
  };

  const displayChartVar = () => {
    setIsChartVisible(!isChartVisible);
  };

  const handleSelectDistribution = (distributionId) => {
    task.applyDistribution(distributionId);
    setOpen(false);
  };

  const handleSelectDistributionClose = () => {
    setOpen(false);
  };

  const handleCalculatePlanClose = () => {
    setCalculatePlanOpen(false);
  };

  const currentValue =
    task.distribution != null ? task.distribution.code : "Uniform";
  return (
    <Box display="flex" sx={{ alignItems: "center" }}>
      <TextField
        select
        disabled={!isTask || task.plannedProgress.length === 0}
        id="task-distribution-shape-select"
        value={currentValue}
        onChange={(e) => handleChange(task, e)}
        variant="standard"
      >
        {selectOptions}
      </TextField>

      <Button size="small" variant="contained" onClick={displayChartVar}>
        Display Chart
      </Button>

      <DistributionForm task={task} isButtonVisible={true} />
      
    <DialogCalculatePlan
       task={task}
       open={isCalculatePlanOpen}
       onCancel={handleCalculatePlanClose}
     />
      <DialogCustomDistribution
       open={open}
       onFinish={handleSelectDistribution}
       onCancel={handleSelectDistributionClose}
    />
    </Box>
    // <FormControl className={classes.taskPanelDistributionPickerItem}>
    //   <InputLabel id="taskDistributionShapeLabel">Shape</InputLabel>
    //   <Select
    //     disabled={!isTask || task.plannedProgress.length === 0}
    //     labelId="taskDistributionShapeLabel"
    //     id="taskDistributionShapeSelect"
    //     value={currentValue}
    //     onChange={(event) => handleChange(task, event)}
    //   >
    //     {selectOptions}
    //   </Select>
    // </FormControl>

    //   <Button
    //     className={classes.taskPanelDistributionPickerItem}
    //     size="small"
    //     variant="contained"
    //     onClick={displayChartVar}
    //   >
    //     Display Chart
    //   </Button>
    //   <DistributionForm
    //     classes={classes}
    //     task={task}
    //     isButtonVisible={true}
    //   />
    // </div>
    // <DisplayChart visibility={isChartVisible} task={task} />

    // </div>
  );
};


export default observer(TaskDistributionPicker);
